<article>
  <button mat-button [mat-menu-trigger-for]="contactMenu">
    <div class="button-body-wrapper">
      <mat-icon class="prefix" [matTooltip]="title">assignment_ind</mat-icon>
      <div class="display-infos">
        <p class="name">{{ user.firstName }} {{ user.lastName }}</p>
        <p class="organization">{{ user.organization?.name }}</p>
      </div>
      <mat-icon class="suffix">chevron_right</mat-icon>
    </div>
  </button>
</article>

<mat-menu #contactMenu>
  @if (user.phone?.length) {
    <a id="phoneBtn" mat-menu-item [href]="'tel:' + userPhone()">
      <mat-icon>call</mat-icon>
      <span>{{ 'uix.contact.card.tooltip.phone' | translate }}</span>
    </a>
  }
  <a id="emailBtn" mat-menu-item [href]="'mailto:' + user.email">
    <mat-icon>email</mat-icon>
    <span>{{ 'uix.contact.card.tooltip.email' | translate }}</span>
  </a>
</mat-menu>
